var React = require('react');

function LogoWindows (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 15.2009L43.4913 9.27788L43.5103 51.2287L0.0397292 51.4763L0 15.2009ZM43.4705 56.0623L43.5043 98.0497L0.0337576 92.0731L0.0313202 55.7806L43.4705 56.0623ZM48.7427 8.50304L106.408 0.086792V50.6952L48.7427 51.153V8.50304ZM106.422 56.4571L106.408 106.838L48.7426 98.6987L48.6618 56.3628L106.422 56.4571Z","fill":"currentColor"}));
}

LogoWindows.defaultProps = {"width":"110","height":"110","viewBox":"0 0 110 110","fill":"none"};

module.exports = LogoWindows;

LogoWindows.default = LogoWindows;
